import { useContext } from 'react';
import { ChartAnimationsContext } from './chartAnimationsTypes';

export const useChartAnimations = () => {
  const context = useContext(ChartAnimationsContext);
  if (context === undefined) {
    throw new Error('useChartAnimations must be used within a ChartAnimationsProvider');
  }
  return context;
};
